import {
  IMAGE_ORIENTATION,
  IMAGE_SIZES,
} from "../../../../constants/constants";
import { Link } from "react-router";
import PropTypes from "prop-types";
import React from "react";

const SirSlide = ({
  index,
  item,
  link,
  showImage,
  sizes,
  listing,
  isSelected,
  title,
}) => {
  let style = {},
    image;
  if (item.orientation === "landscape") {
    style.objectFit = "cover";
    style.fontFamily = "object-fit: cover";
  }
  if (window.location.protocol === "https:") {
    // TODO: delete this when images are served over https
    // images served over http do not load if using srcSet
    image = <img alt={"image-" + index} src={getSrc(item)} style={style} />;
  } else {
    image = (
      <img
        alt={`${listing.title} view ${index + 1}`}
        src={getSrc(item, 330)}
        sizes={sizes}
        srcSet={`
          ${getSrc(item, 330)} 500w,
          ${getSrc(item, 400)} 600w,
          ${getSrc(item)} 750w`}
        style={style}
      />
    );
  }
  return (
    <div className="slide">
      {link ? (
        <Link
          tabIndex={isSelected ? "0" : "-1"}
          to={link}
          aria-label={`Read More about ${listing.title}, ${listing.cityStateCountry}`}
        >
          {showImage ? image : null}
        </Link>
      ) : (
        image
      )}
    </div>
  );
};

SirSlide.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  link: PropTypes.string,
  showImage: PropTypes.bool,
  sizes: PropTypes.string,
};

SirSlide.defaultProps = {
  sizes: "(min-width: 768px) 50vw, (min-width: 1100px) 496px, 100vw",
};

export default SirSlide;

function getSrc(item, height) {
  if (item.orientation === IMAGE_ORIENTATION.LANDSCAPE) {
    switch (height) {
      case 330:
        return item.src.replace(
          IMAGE_SIZES.LIST_LANDSCAPE,
          IMAGE_SIZES.LIST_LANDSCAPE_330
        );
      case 400:
        return item.src.replace(
          IMAGE_SIZES.LIST_LANDSCAPE,
          IMAGE_SIZES.LIST_LANDSCAPE_400
        );
      default:
        return item.src;
    }
  } else {
    switch (height) {
      case 330:
        return item.src.replace(
          IMAGE_SIZES.LIST_PORTRAIT,
          IMAGE_SIZES.LIST_PORTRAIT_330
        );
      case 400:
        return item.src.replace(
          IMAGE_SIZES.LIST_PORTRAIT,
          IMAGE_SIZES.LIST_PORTRAIT_400
        );
      default:
        return item.src;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/search/result/mini-slideshow/sir-slide.js